var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    [
      _c(
        "Box",
        {
          staticClass: "dashboards__header",
          attrs: { tag: "header", paddingX: 5 }
        },
        [
          _c(
            "Box",
            {
              staticClass: "max-width",
              attrs: { display: "flex", flexAlign: "center" }
            },
            [
              _c(
                "Box",
                { staticClass: "user-thumbs", attrs: { display: "flex" } },
                [
                  _c("Avatar", {
                    staticClass: "avatar",
                    attrs: {
                      username: `${_vm.userProvider.user.firstName} ${_vm.userProvider.user.lastName}`,
                      size: 60,
                      rounded: "",
                      shadow: ""
                    }
                  })
                ],
                1
              ),
              _c(
                "Box",
                { staticClass: "user__name", attrs: { marginLeft: 9 } },
                [
                  _c(
                    "Box",
                    { attrs: { display: "flex", flexAlign: "center" } },
                    [
                      _c(
                        "layoutText",
                        {
                          staticClass: "name",
                          attrs: {
                            fontSize: 4,
                            fontWeight: "normal",
                            marginRight: 4
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.userProvider.user &&
                                  _vm.userProvider.user.firstName
                              ) +
                              " " +
                              _vm._s(
                                _vm.userProvider.user &&
                                  _vm.userProvider.user.lastName
                              ) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.userType == "Accounting"
        ? _c("AccountingDashboard")
        : _vm.userType == "DataServices"
        ? _c("DSDashboard")
        : _c("FundraiserDashboard")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }